/**
 * Pre-defined list of areas categorized by district
 * Specially focused on Tamil Nadu & major metropolitan regions where Mr.Coach Pro operates.
 */

export const PREDEFINED_DISTRICT_AREAS = {
  // ── CHENNAI ─────────────────────────────────────────────────────────────
  chennai: [
    'Adambakkam',
    'Adyar',
    'Alandur',
    'Alwarpet',
    'Ambattur',
    'Aminjikarai',
    'Anna Nagar',
    'Anna Nagar East',
    'Anna Nagar West',
    'Arumbakkam',
    'Ashok Nagar',
    'Avadi',
    'Ayanavaram',
    'Besant Nagar',
    'Broadway',
    'Chetpet',
    'Choolai',
    'Choolaimedu',
    'Chromepet',
    'Egmore',
    'Ekkattuthangal',
    'Ennore',
    'George Town',
    'Gopalapuram',
    'Guindy',
    'Injambakkam',
    'Jafferkhanpet',
    'K.K. Nagar',
    'Karapakkam',
    'Keelkattalai',
    'Kilpauk',
    'Kodambakkam',
    'Kodungaiyur',
    'Kolathur',
    'Korattur',
    'Kotturpuram',
    'Koyambedu',
    'Madhavaram',
    'Madipakkam',
    'Manali',
    'Manapakkam',
    'Mandaveli',
    'Medavakkam',
    'Meenambakkam',
    'Mogappair',
    'Mugalivakkam',
    'Mylapore',
    'Nandambakkam',
    'Nandanam',
    'Nanganallur',
    'Navalur',
    'Neelankarai',
    'Nungambakkam',
    'OMR (Old Mahabalipuram Road)',
    'Otteri',
    'Padi',
    'Pallavaram',
    'Pallikaranai',
    'Pammal',
    'Park Town',
    'Perambur',
    'Perungalathur',
    'Perungudi',
    'Poonamallee',
    'Porur',
    'Purasawalkam',
    'Ramapuram',
    'Red Hills',
    'Royapettah',
    'Royapuram',
    'Saidapet',
    'Saligramam',
    'Santhome',
    'Selaiyur',
    'Semmancheri',
    'Shenoy Nagar',
    'Sholinganallur',
    'Sithalapakkam',
    'Sowcarpet',
    'St. Thomas Mount',
    'T. Nagar',
    'Tambaram',
    'Tambaram East',
    'Tambaram West',
    'Teynampet',
    'Tharamani',
    'Thirumangalam',
    'Thirumullaivoyal',
    'Thiruvanmiyur',
    'Thoraipakkam',
    'Tirusulam',
    'Tiruvottiyur',
    'Urapakkam',
    'Vadapalani',
    'Valasaravakkam',
    'Vanagaram',
    'Velachery',
    'Vepery',
    'Villivakkam',
    'Virugambakkam',
    'Vyasarpadi',
    'Washermanpet',
    'West Mambalam',
  ],

  // ── CHENGALPATTU / CHINGLEPUT ────────────────────────────────────────────
  chingleput: [
    'Alathur',
    'Chengalpattu Town',
    'Guduvanchery',
    'Kalpakkam',
    'Kelambakkam',
    'Kovalam',
    'Madambakkam',
    'Mahindra World City',
    'Mamallapuram (Mahabalipuram)',
    'Maraimalai Nagar',
    'Melmaruvathur',
    'Nandivaram',
    'Otteri',
    'Padur',
    'Paiyanur',
    'Palavakkam',
    'Perungalathur',
    'Ponmar',
    'Pudupakkam',
    'Singaperumal Koil',
    'Siruseri',
    'Thiruporur',
    'Urapakkam',
    'Vandalur',
  ],
  chengalpattu: [
    'Alathur',
    'Chengalpattu Town',
    'Guduvanchery',
    'Kalpakkam',
    'Kelambakkam',
    'Kovalam',
    'Madambakkam',
    'Mahindra World City',
    'Mamallapuram (Mahabalipuram)',
    'Maraimalai Nagar',
    'Melmaruvathur',
    'Nandivaram',
    'Otteri',
    'Padur',
    'Paiyanur',
    'Palavakkam',
    'Perungalathur',
    'Ponmar',
    'Pudupakkam',
    'Singaperumal Koil',
    'Siruseri',
    'Thiruporur',
    'Urapakkam',
    'Vandalur',
  ],

  // ── KANCHIPURAM ──────────────────────────────────────────────────────────
  kanchipuram: [
    'Enathur',
    'Kanchipuram Town',
    'Kundrathur',
    'Madurantakam',
    'Mangadu',
    'Oragadam',
    'Padappai',
    'Sriperumbudur',
    'Sunguvarchatram',
    'Thirukazhukundram',
    'Uthiramerur',
    'Walajabad',
  ],

  // ── TIRUVALLUR ───────────────────────────────────────────────────────────
  tiruvallur: [
    'Ambattur Industrial Estate',
    'Avadi',
    'Gummidipoondi',
    'Minjur',
    'Pattabiram',
    'Ponneri',
    'Poonamallee',
    'Red Hills',
    'Sholavaram',
    'Thiruverkadu',
    'Tirunindravur',
    'Tiruvallur Town',
    'Uthukottai',
    'Veppampattu',
  ],

  // ── COIMBATORE ───────────────────────────────────────────────────────────
  coimbatore: [
    'Gandhipuram',
    'Ganapathy',
    'Hopes College',
    'Kalapatti',
    'Kovaipudur',
    'Kuniyamuthur',
    'Malumichampatti',
    'Ondipudur',
    'Peelamedu',
    'Periyanaickenpalayam',
    'Podanur',
    'Pollachi',
    'Ramanathapuram',
    'RS Puram',
    'Saibaba Colony',
    'Saravanampatti',
    'Singanallur',
    'Sulur',
    'Thudiyalur',
    'Ukkadam',
    'Vadavalli',
  ],

  // ── MADURAI ──────────────────────────────────────────────────────────────
  madurai: [
    'Alagarkovil',
    'Anna Nagar',
    'Avaniyapuram',
    'Chinthamani',
    'Goripalayam',
    'Iyer Bungalow',
    'K. Pudur',
    'Kalavasal',
    'Kochadai',
    'Mattuthavani',
    'Meenakshi Nagar',
    'Narimedu',
    'Othakadai',
    'Palanganatham',
    'Pasumalai',
    'SS Colony',
    'Sellur',
    'Simmakkal',
    'Tallakulam',
    'Teppakulam',
    'Thirunagar',
    'Tiruparankundram',
    'Villapuram',
  ],

  // ── SALEM ────────────────────────────────────────────────────────────────
  salem: [
    'Alagapuram',
    'Ammapet',
    'Asthampatti',
    'Fairlands',
    'Hasthampatti',
    'Jagir Ammapalayam',
    'Kannankurichi',
    'Meyyanur',
    'Omalur',
    'Salem Junction',
    'Shevapet',
    'Suramangalam',
  ],

  // ── TIRUCHIRAPPALLI / TRICHY ─────────────────────────────────────────────
  tiruchirappalli: [
    'Cantonment',
    'K.K. Nagar',
    'Kattur',
    'Lalgudi',
    'Manachanallur',
    'Srirangam',
    'Thillai Nagar',
    'Thiruverumbur',
    'Woraiyur',
  ],
  trichy: [
    'Cantonment',
    'K.K. Nagar',
    'Kattur',
    'Lalgudi',
    'Manachanallur',
    'Srirangam',
    'Thillai Nagar',
    'Thiruverumbur',
    'Woraiyur',
  ],

  // ── BENGALURU / BANGALORE ────────────────────────────────────────────────
  bangalore: [
    'BTM Layout',
    'Banashankari',
    'Bannerghatta Road',
    'Bellandur',
    'Electronic City',
    'HSR Layout',
    'Indiranagar',
    'JP Nagar',
    'Jayanagar',
    'Koramangala',
    'Malleshwaram',
    'Marathahalli',
    'Rajajinagar',
    'Whitefield',
    'Yelahanka',
  ],
  bengaluru: [
    'BTM Layout',
    'Banashankari',
    'Bannerghatta Road',
    'Bellandur',
    'Electronic City',
    'HSR Layout',
    'Indiranagar',
    'JP Nagar',
    'Jayanagar',
    'Koramangala',
    'Malleshwaram',
    'Marathahalli',
    'Rajajinagar',
    'Whitefield',
    'Yelahanka',
  ],

  // ── HYDERABAD ────────────────────────────────────────────────────────────
  hyderabad: [
    'Ameerpet',
    'Banjara Hills',
    'Begumpet',
    'Gachibowli',
    'Hitec City',
    'Jubilee Hills',
    'Kondapur',
    'Kukatpally',
    'Madhapur',
    'Manikonda',
    'Miyapur',
    'Secunderabad',
  ],
};

/**
 * Returns a title-cased clean string
 */
function toTitleCase(str) {
  if (!str) return '';
  return str
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/**
 * Helper to get pre-defined areas for a given district name or district ID.
 * Merges pre-defined list with any existing unique areas present in the user dataset.
 *
 * @param {string|number} districtIdentifier - District ID or District Name
 * @param {Array} districtsList - List of district objects [{ id, name, ... }]
 * @param {Array} usersList - List of user objects from the database
 * @returns {Array<string>} Alphabetically sorted unique areas
 */
export function getAreasForDistrict(districtIdentifier, districtsList = [], usersList = []) {
  if (!districtIdentifier) {
    // If no district is specified, aggregate all unique areas across all users & predefined districts
    const set = new Set();
    Object.values(PREDEFINED_DISTRICT_AREAS).forEach((areas) => {
      areas.forEach((a) => set.add(a));
    });
    usersList.forEach((u) => {
      const a = u.area || u.mongo_location?.area;
      if (a && typeof a === 'string' && a.trim()) {
        set.add(toTitleCase(a));
      }
    });
    return Array.from(set).sort((a, b) => a.localeCompare(b));
  }

  // Resolve district name
  let districtName = '';
  if (typeof districtIdentifier === 'number' || !isNaN(Number(districtIdentifier))) {
    const found = districtsList.find((d) => String(d.id) === String(districtIdentifier));
    if (found) {
      districtName = found.name;
    }
  } else {
    districtName = String(districtIdentifier);
  }

  const normalizedDistrict = districtName.toLowerCase().trim();

  // Find in predefined map
  const predefined =
    PREDEFINED_DISTRICT_AREAS[normalizedDistrict] ||
    Object.entries(PREDEFINED_DISTRICT_AREAS).find(([k]) =>
      normalizedDistrict.includes(k) || k.includes(normalizedDistrict)
    )?.[1] ||
    [];

  const areaSet = new Set(predefined);

  // Merge with areas already saved in the users dataset for this district
  if (Array.isArray(usersList)) {
    usersList.forEach((u) => {
      const matchDistrict =
        String(u.district_id) === String(districtIdentifier) ||
        (u.district && u.district.toLowerCase().trim() === normalizedDistrict) ||
        (u.mongo_location?.district && u.mongo_location.district.toLowerCase().trim() === normalizedDistrict);

      if (matchDistrict) {
        const areaStr = u.area || u.mongo_location?.area;
        if (areaStr && typeof areaStr === 'string' && areaStr.trim()) {
          areaSet.add(toTitleCase(areaStr));
        }
      }
    });
  }

  return Array.from(areaSet).sort((a, b) => a.localeCompare(b));
}
